import { render, staticRenderFns } from "./Motor.vue?vue&type=template&id=371ab3d2&"
import script from "./Motor.vue?vue&type=script&lang=js&"
export * from "./Motor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports